/* eslint-disable */
export default {
  ok: '確定',
} as const;

// @key: @#@"ok"@#@ @source: @#@"OK"@#@
